import React from 'react';
import { appendUtmParams } from '../utils/utm-params';

/**
 * ExternalLink Component
 * Automatically appends UTM parameters to external links (especially my.brain-event.com)
 * 
 * Usage:
 * <ExternalLink href="https://my.brain-event.com" className="btn btn-primary">
 *   Buy Ticket
 * </ExternalLink>
 */
const ExternalLink = ({ href, children, className, ...props }) => {
  const handleClick = (e) => {
    // Only append UTM params for external links to my.brain-event.com
    if (href && href.includes('my.brain-event.com')) {
      e.preventDefault();
      const urlWithParams = appendUtmParams(href);
      window.location.href = urlWithParams;
    }
    // For anchor links (#pachete, etc.), let default behavior happen
  };

  return (
    <a href={href} className={className} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default ExternalLink;
